import React, { useState } from 'react';
import { Row, Col, Form, Input, Button } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { Card } from 'src/components';
import LoginIcon from 'src/assets/images/logo.png';
import { Notification } from 'src/utils';
import { signIn } from 'src/store/auth/actions';

import { IProps } from './auth.type';
import { rules } from './auth.utils';
import { Wrapper, CardWrapper, Image, Subtitle } from './auth.style';

const AuthScreen: React.FC<IProps> = (props) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [sending, setSending] = useState(false);

  const handleSignIn = async (values: any) => {
    setSending(true);

    try {
      const response = await props.signIn(values);

      if (!!response) {
        navigate('painel/board/');
      }
    } catch {
      Notification.error({
        message: 'Ocorreu um erro tente novamente mais tarde.',
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Wrapper>
      <Row justify="center" align="middle" style={{ width: '100%' }}>
        <Col xs={20} sm={20} md={14} lg={8} xxl={6}>
          <CardWrapper>
            <Card>
              <Image src={LoginIcon} alt="login" />
              <Subtitle>
                {intl.formatMessage({ id: 'form.login.subtitle' })}
              </Subtitle>
              <Form
                onFinish={handleSignIn}
                layout="vertical"
                requiredMark={false}
                colon={false}
                size="large"
              >
                <Form.Item label="E-mail" name="email" rules={rules.email}>
                  <Input
                    placeholder="Digite seu e-mail"
                    autoComplete="email"
                    inputMode="email"
                    autoFocus
                    allowClear
                    prefix={<MailOutlined />}
                  />
                </Form.Item>
                <Form.Item
                  label="Senha"
                  name="password"
                  rules={rules.password}
                >
                  <Input.Password
                    placeholder="Digite sua senha"
                    autoComplete="current-password"
                    prefix={<LockOutlined />}
                  />
                </Form.Item>

                <Form.Item className="mb-0">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={sending}
                    block
                  >
                    Entrar
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </CardWrapper>
        </Col>
      </Row>
    </Wrapper>
  );
};

export default connect(undefined, { signIn })(AuthScreen);
